<form-control-container #container [control]="controlInstance" [class.readonly]="isReadonlyValue">
      <div label-extension>
        <ng-content select="[label-extension]"></ng-content>
      </div>
    
      <ng-container *ngIf="!isReadonlyValue">
        <div class="input-group">
          <span class="input-group-addon" *ngIf="sign">
            {{sign}}
          </span>
          <input
                 type="text"
                 class="form-control"
                 [maskito]="maskitoOptions"
                 [ngModel]="internalValue"
                 (ngModelChange)="onInternalValueChanged($event)"
                 [ngClass]="{invalid: invalid}"
                 [id]="controlId"
                 [attr.name]="inputName"
                 [disabled]="disabled"
                 (focusout)="touch()"
                 [autocomplete]="autocomplete ? 'on' : 'turn-off'"                 
                 [attr.placeholder]="placeholder"
                 [attr.tabindex]="tabindex"
                 />
    
          <ng-content select="[after]"></ng-content>
        </div>
      </ng-container>
    
      <ng-container *ngIf="isReadonlyValue">
        <span class="readonly-value">{{value | wafCurrency:sign}}</span>
      </ng-container>
    
    </form-control-container>